import { Site } from './home.page.jsx';
import { useState } from 'react';
import clsx from 'clsx';
import { Link } from '@inertiajs/react';
import { usePage } from '@inertiajs/react';
 
export default function LoginPage({ errors }) {

  const { env } = usePage().props;
  const allowGuestLogin = (env?.stage || 'prod') == 'dev';

  const [acceptTerms, setAcceptTerms] = useState(false);
  const [acceptBeta, setAcceptBeta] = useState(false);

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8 text-gray-200">
        
        <Link href="/" className="flex flex-col items-center justify-center">
          <img
            className="h-16 w-auto mt-5 -ml-4"
            src="/images/mcloud_logo.png"
            alt="MHub Cloud Logo"
          />
        </Link>
        
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-12 text-center text-2xl/9 font-bold tracking-tight text-blue">
            Sign in to your account.
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-slate-200 px-6 py-10 shadow rounded-lg sm:px-12">

            {errors.github && (
              <div className="text-red-600 text-center mb-5 bg-red-200 border border-red-500 rounded p-3">
                {errors.github}
              </div>
            )}

            <div>
              <div className="mt-2">
                <Link
                  onClick={e => (!acceptBeta || !acceptTerms) && e.preventDefault()}
                  href="/auth/github"
                  className={clsx("flex w-full items-center justify-center gap-3 rounded-md bg-emerald-500 px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-emerald-700  focus-visible:ring-transparent", (!acceptBeta || !acceptTerms) ? 'cursor-not-allowed opacity-50' : 'hover:bg-emerald-400')}
                >
                  <svg fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" className="size-5 fill-gray-900">
                    <path
                      d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z"
                      clipRule="evenodd"
                      fillRule="evenodd"
                    />
                  </svg>
                  <span className="text-sm/6 font-semibold">Login with GitHub</span>
                </Link>
                { allowGuestLogin && 
                <Link
                  onClick={e => (!acceptBeta || !acceptTerms) && e.preventDefault()}
                  href="/guest-login"
                  method="post"
                  className={clsx("mt-5 flex w-full items-center justify-center gap-3 rounded-md bg-emerald-500 px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-emerald-700  focus-visible:ring-transparent", (!acceptBeta || !acceptTerms) ? 'cursor-not-allowed opacity-50' : 'hover:bg-emerald-400')}
                >
                  <span className="text-sm/6 font-semibold">Dev Guest Login</span>
                </Link> }
              </div>
              <div className="relative my-10">
                <div className="relative flex justify-center text-sm/6 font-medium">
                  <div aria-hidden="true" className="absolute inset-0 flex items-center">
                    <div className="border-t border-gray-400 absolute left-0" style={{ width: "calc(50% - 50px)" }} />
                    <div className="border-t border-gray-400 absolute right-0" style={{ width: "calc(50% - 50px)" }} />
                  </div>
                  <span className="px-6 text-gray-600">Please Note</span>
                </div>
              </div>
              <div className="mt-10 flex flex-col gap-6">

                <div className="flex gap-3">
                  <div className="flex h-6 shrink-0 items-center">
                    <div className="group grid size-4 grid-cols-1">
                      <input
                        checked={acceptTerms}
                        onChange={() => setAcceptTerms(!acceptTerms)}
                        id="acceptTerms"
                        name="acceptTerms"
                        type="checkbox"
                        aria-describedby="acceptTerms-description"
                        className="col-start-1 row-start-1 appearance-none rounded border border-slate-700 bg-slate-600 checked:border-emerald-600 checked:bg-emerald-600 indeterminate:border-emerald-600 indeterminate:bg-emerald-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto cursor-pointer"
                      />
                      <svg
                        fill="none"
                        viewBox="0 0 14 14"
                        className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-gray-200 group-has-[:disabled]:stroke-gray-950/25"
                      >
                        <path
                          d="M3 8L6 11L11 3.5"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="opacity-0 group-has-[:checked]:opacity-100"
                        />
                        <path
                          d="M3 7H11"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="opacity-0 group-has-[:indeterminate]:opacity-100"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="text-sm/6">
                    <label htmlFor="acceptTerms" className="font-medium text-gray-700 cursor-pointer">
                      Accept our Terms and Conditions and Privacy Policy
                    </label>
                    <p id="acceptTerms-description" className="text-gray-500">
                      When you connect your GitHub account and when using our services, you agree to our <Link href="/legal/agb" className='text-emerald-700'>Terms of Use</Link> and <Link href="/legal/privacy" className='text-emerald-700'>Privacy Policy</Link>.
                    </p>
                  </div>
                </div>

                <div className="flex gap-3">
                  <div className="flex h-6 shrink-0 items-center">
                    <div className="group grid size-4 grid-cols-1">
                      <input
                        checked={acceptBeta}
                        onChange={() => setAcceptBeta(!acceptBeta)}
                        id="acceptBeta"
                        name="acceptBeta"
                        type="checkbox"
                        aria-describedby="acceptBeta-description"
                        className="col-start-1 row-start-1 appearance-none rounded border border-slate-700 bg-slate-600 checked:border-emerald-600 checked:bg-emerald-600 indeterminate:border-emerald-600 indeterminate:bg-emerald-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto cursor-pointer"
                      />
                      <svg
                        fill="none"
                        viewBox="0 0 14 14"
                        className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-gray-200 group-has-[:disabled]:stroke-gray-950/25"
                      >
                        <path
                          d="M3 8L6 11L11 3.5"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="opacity-0 group-has-[:checked]:opacity-100"
                        />
                        <path
                          d="M3 7H11"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="opacity-0 group-has-[:indeterminate]:opacity-100"
                        />
                      </svg>
                    </div>
                  </div>
                  <div className="text-sm/6">
                    <label htmlFor="acceptBeta" className="font-medium text-gray-700 cursor-pointer">
                      Beta Testing
                    </label>
                    <p id="acceptBeta-description" className="text-gray-500">
                      This project is currently in beta testing. Data can be reset, access restricted and functionality removed or updated at any time and without notice.
                    </p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
    </div>
  );
}

LoginPage.layout = page => <Site showHeader={false}>{ page }</Site>